import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'dmp-export-table',
    templateUrl: './export-table.component.html',
    styleUrls: ['./export-table.component.scss'],
    standalone: false
})
export class ExportTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
